<template>
  <button
    :class="`${btnClassName} pure-button`"
    :disabled="disabled"
    @click="onClick"
    :aria-label="ariaLabel"
    :aria-pressed="ariaPressed"
  >
    <i v-if="showIcon" :class="iconClassName"></i>
    <span v-if="showText" :class="textClassName">{{ text }}</span>
  </button>
</template>
<script>
export default {
  props: {
    btnClassName: {
      type: String
    },
    iconClassName: {
      type: String
    },
    textClassName: {
      type: String
    },
    onClick: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showText: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    ariaLabel: {
      type: String
    },
    ariaPressed: {
      type: Boolean
    }
  }
};
</script>

<style scoped lang="scss">
button {
  height: 35px;
  width: 100%;
  color: #000000;
  @media screen and (max-width: 600px) {
    height: 25px;
  }
}
button:disabled {
  color: lightgrey !important;
}
button:disabled i {
  color: lightgrey !important;
}
span {
  font-weight: bold;
  @media screen and (max-width: 600px) {
    font-size: 10px;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
.off span {
  color: white;
}
</style>
